import { FC, MouseEvent, SyntheticEvent } from 'react';
import clsx from 'clsx';
import _find from 'lodash/find';

import { UnderlinedButton } from '@components/shared/buttons/underlined-button/UnderlinedButton';
import Slider from '@components/shared/form-elements/Slider/Slider';
import { IFilterOptions, IFilterProp, ISetFiltersParam } from '@types';
import { ATTRIBUTE_PRICE_RANGE_PATH } from './constants';

interface IProps {
  filters: ISetFiltersParam;
  setFilters: (newFilters: IFilterProp[]) => void;
  classes: { [key: string]: string };
  label?: string;
  filterOptionsData: IFilterOptions;
}

const PriceRangeOptions: FC<IProps> = ({ classes, label: labelSection, filterOptionsData, setFilters, filters }) => {
  const priceOptions = filterOptionsData.price.sort((a, b) => a - b);
  const opts = [priceOptions[1], priceOptions[priceOptions.length - 1]];

  opts[0] = Math.floor(opts[0]);
  opts[1] = Math.ceil(opts[1]);

  const filtersFast = filters.arrayRes || [];

  const priceFilter = filtersFast.find((filter) => filter.path === ATTRIBUTE_PRICE_RANGE_PATH);
  const filterValues =
    priceFilter && priceFilter.value ? priceFilter.value.split('-').map((val) => parseInt(val, 10)) : opts;

  const arraySelected = filtersFast.filter((item) => item.path === ATTRIBUTE_PRICE_RANGE_PATH);
  const arraySelectedLast = arraySelected && arraySelected.length ? arraySelected[arraySelected.length - 1] : null;

  const handleResetPriceFilters = (ev: SyntheticEvent | MouseEvent) => {
    if (arraySelectedLast) {
      ev.stopPropagation();
      setFilters(filtersFast.filter((item) => item.path !== ATTRIBUTE_PRICE_RANGE_PATH));
    }
  };

  const handlePriceRangeChange = (values: number[]) => {
    const newFilterPropValue: IFilterProp = {
      rule: 'range',
      path: ATTRIBUTE_PRICE_RANGE_PATH,
      value: values.join('-')
    };

    const priceFilterObj = _find(filtersFast, { path: ATTRIBUTE_PRICE_RANGE_PATH });
    if (priceFilterObj) {
      priceFilterObj.value = newFilterPropValue.value;
    } else {
      filtersFast.push(newFilterPropValue);
    }

    setFilters(filtersFast);
  };

  return (
    <div className={classes.paddedPanel}>
      <div className={classes.paddedPanelWrapper}>
        <div className={classes.simpleBottom}>
          <h6 className={classes.expansionHeader}>{labelSection}</h6>
          <UnderlinedButton
            className={clsx(classes.expansionReset, {
              [classes.expansionResetActive]: !!arraySelectedLast
            })}
            onClick={handleResetPriceFilters}
            label="Скинути"
          />
        </div>
        <Slider
          title="Ціна за шт, ₴"
          min={opts[0]}
          max={opts[1]}
          value={filterValues}
          onChange={handlePriceRangeChange}
          withInputs={true}
          getAriaLabel={() => 'Ціна за шт, ₴'}
          id="priceRange"
        />
      </div>
    </div>
  );
};

export default PriceRangeOptions;
